import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Grid,
  Box,
  TextField,
  IconButton,
  Collapse,
  Divider,
  FormControlLabel,
  Radio,
  MenuItem,
  Select,
  FormControl,
  FormGroup,
  Checkbox,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import { useNavigate, useParams } from "react-router";
import api from "_api";
import InputAdornment from "@mui/material/InputAdornment";
import { formatDateMonthYear } from "utils/helpers/format";
import CustomizeDatePicker from "components/DatePicker";

const typeMapping = {
  1: "pawn",
  2: "car",
  3: "land",
};

const durationOptions = [
  { id: 1, label: "3 เดือน", value: "3 เดือน" },
  { id: 2, label: "6 เดือน", value: "6 เดือน" },
  { id: 3, label: "1 ปี", value: "1 ปี" },
  { id: 4, label: "2 ปี", value: "2 ปี" },
  { id: 5, label: "3 ปี", value: "3 ปี" },
  { id: 6, label: "4 ปี", value: "4 ปี" },
  { id: 7, label: "5 ปี", value: "5 ปี" },
];

const requiredFields = [
  "invoiceDate",
  "item",
  "startDate",
  "duration",
  "annualCost",
];

const isSectionFilled = (val) => {
  return requiredFields.some(
    (key) =>
      val?.[key] !== "" && val?.[key] !== null && val?.[key] !== undefined
  );
};

const optionalSectionSchema = Yup.object().shape({
  invoiceDate: Yup.string().required("กรุณาระบุวันที่ออกใบแจ้งหนี้"),
  item: Yup.string().required("กรุณาระบุรายการ"),
  startDate: Yup.string().required("กรุณาระบุวันเริ่มต้น"),
  duration: Yup.string().required("กรุณาระบุระยะเวลา"),
  annualCost: Yup.number().required("กรุณาระบุค่าบริการ").min(0),
  discountAmount: Yup.number().when("discount", (discount, schema) => {
    if (discount === true || discount === 1) {
      return schema
        .required("กรุณาระบุเปอร์เซ็นส่วนลด")
        .min(0)
        .max(100, "ต้องไม่เกิน 100%");
    }
    return schema.notRequired();
  }),
  netAmount: Yup.number()
    .required("กรุณาระบุค่าบริการ")
    .min(0, "ยอดสุทธิต้องมากกว่าหรือเท่ากับ 0"),
  type: Yup.array()
    .of(Yup.string().oneOf(["pawn", "car", "land"]))
    .min(1, "กรุณาเลือกประเภทอย่างน้อย 1 ประเภท"),
});

const validationSchema = Yup.object().shape({
  pawnShop: Yup.lazy((val) =>
    isSectionFilled(val) ? optionalSectionSchema : Yup.object().notRequired()
  ),
  usedCar: Yup.lazy((val) =>
    isSectionFilled(val) ? optionalSectionSchema : Yup.object().notRequired()
  ),
  land: Yup.lazy((val) =>
    isSectionFilled(val) ? optionalSectionSchema : Yup.object().notRequired()
  ),
});

const transformSection = (section) => ({
  ...section,
  annualCost: parseFloat(section.annualCost || 0),
  discount: section.discount ? 1 : 0,
  discountAmount: parseFloat(section.discountAmount || 0),
  netAmount: parseFloat(section.netAmount || 0),
});

// const SectionForm = ({
//   title,
//   sectionKey,
//   formik,
//   expandedRow,
//   handleExpandClick,
//   clearOtherSections,
// }) => {
//   const values = formik.values[sectionKey];
//   const errors = formik.errors[sectionKey] || {};
//   const touched = formik.touched[sectionKey] || {};

//   // calculate netAmount
//   const calculateNetAmount = (
//     annualCostStr,
//     discountAmountStr,
//     discountFlag
//   ) => {
//     const cost = parseFloat(annualCostStr);
//     const percent = parseFloat(discountAmountStr);

//     if (!isNaN(cost)) {
//       if (discountFlag && !isNaN(percent) && percent > 0) {
//         return (cost - (cost * percent) / 100).toFixed(2);
//       } else {
//         return cost.toFixed(2);
//       }
//     }
//     return "";
//   };

//   return (
//     <Paper sx={{ mt: 5, p: 2, borderRadius: "12px" }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Typography sx={{ mb: 1, ml: 2 }} variant="h6">
//           {title}
//         </Typography>
//         {/* <IconButton
//           size="small"
//           onClick={() => handleExpandClick(sectionKey)}
//           style={{
//             transform: expandedRow === sectionKey ? "rotate(180deg)" : "none",
//             transition: "transform 0.2s ease-in-out",
//           }}
//         >
//           <ExpandMoreIcon />
//         </IconButton> */}
//       </Box>
//       <Collapse in={expandedRow === sectionKey}>
//         <Divider />
//         <Grid container spacing={2} sx={{ p: 2 }}>
//           <Grid item xs={12}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={2} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   วันที่ออกใบแจ้งหนี้
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={4} lg={4}>
//                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                   <DatePicker
//                     label="วันที่ออกใบแจ้งหนี้"
//                     value={
//                       values.invoiceDate ? moment(values.invoiceDate) : null
//                     }
//                     // onChange={(date) =>
//                     //   formik.setFieldValue(`${sectionKey}.invoiceDate`, date ? date.format("YYYY-MM-DD") : "")
//                     // }
//                     onChange={(date) => {
//                       clearOtherSections(sectionKey);
//                       formik.setFieldValue(
//                         `${sectionKey}.invoiceDate`,
//                         date ? date.format("YYYY-MM-DD") : ""
//                       );
//                     }}
//                     slotProps={{
//                       textField: {
//                         fullWidth: true,
//                         error:
//                           touched.invoiceDate && Boolean(errors.invoiceDate),
//                         helperText: touched.invoiceDate && errors.invoiceDate,
//                       },
//                     }}
//                   />
//                 </LocalizationProvider>
//               </Grid>
//             </Grid>
//           </Grid>
//           <Grid item xs={12}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={2} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   ชื่อรายการ
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={4} lg={4}>
//                 <TextField
//                   fullWidth
//                   label="ชื่อรายการ"
//                   name={`${sectionKey}.item`}
//                   value={values.item}
//                   // onChange={formik.handleChange}
//                   onChange={(e) => {
//                     clearOtherSections(sectionKey); // 👈 เคลียร์ก่อน
//                     formik.handleChange(e);
//                   }}
//                   error={touched.item && Boolean(errors.item)}
//                   helperText={touched.item && errors.item}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>
//           <Grid item xs={12}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={2} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   ประเภท
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} lg={10}>
//                 <FormGroup row>
//                   {["pawn", "car", "land"].map((key) => (
//                     <FormControlLabel
//                       key={key}
//                       control={
//                         <CheckBox
//                           name={key}
//                           // checked={values[key] || false}
//                           // onChange={formik.handleChange}
//                           onChange={(e) => {
//                             const checked = e.target.checked;
//                             let types = [];

//                             if (checked) {
//                               types.push(key);
//                             } else {
//                               types = types.filter((type) => type !== key);
//                             }
//                             formik.setFieldValue("type", types);
//                           }}
//                           color="primary"
//                           size="small"
//                         />
//                       }
//                       label={
//                         key === "pawn"
//                           ? "ระบบโรงรับจำนำ หรือร้านค้าทั่วไป"
//                           : key === "car"
//                           ? "ระบบรถมือสอง"
//                           : "ระบบที่ดิน"
//                       }
//                     />
//                   ))}
//                 </FormGroup>
//               </Grid>
//             </Grid>
//           </Grid>
//           <Grid item xs={12}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   วันเริ่มใช้งาน
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} lg={4}>
//                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                   <DatePicker
//                     label="เริ่มใช้งาน"
//                     value={values.startDate ? moment(values.startDate) : null}
//                     // onChange={(date) =>
//                     //   formik.setFieldValue(`${sectionKey}.startDate`, date ? date.format("YYYY-MM-DD") : "")
//                     // }
//                     onChange={(date) => {
//                       clearOtherSections(sectionKey);
//                       formik.setFieldValue(
//                         `${sectionKey}.startDate`,
//                         date ? date.format("YYYY-MM-DD") : ""
//                       );
//                     }}
//                     slotProps={{
//                       textField: {
//                         fullWidth: true,
//                         error: touched.startDate && Boolean(errors.startDate),
//                         helperText: touched.startDate && errors.startDate,
//                       },
//                     }}
//                   />
//                 </LocalizationProvider>
//               </Grid>
//             </Grid>
//           </Grid>
//           <Grid item xs={12}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   ระยะเวลา
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} lg={4}>
//                 <FormControl
//                   fullWidth
//                   error={touched.duration && Boolean(errors.duration)}
//                 >
//                   <Select
//                     displayEmpty
//                     name={`${sectionKey}.duration`}
//                     value={values.duration}
//                     // onChange={formik.handleChange}
//                     onChange={(e) => {
//                       clearOtherSections(sectionKey);
//                       formik.handleChange(e);
//                     }}
//                   >
//                     <MenuItem disabled value="">
//                       เลือกระยะเวลา
//                     </MenuItem>
//                     {durationOptions.map((opt) => (
//                       <MenuItem key={opt.id} value={opt.value}>
//                         {opt.label}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} lg={4}>
//                 <TextField
//                   fullWidth
//                   label="ค่าบริการ(ต่อปี)"
//                   name={`${sectionKey}.annualCost`}
//                   type="number"
//                   value={values.annualCost}
//                   // onChange={formik.handleChange}
//                   onChange={(e) => {
//                     clearOtherSections(sectionKey);
//                     const newVal = e.target.value;
//                     formik.setFieldValue(`${sectionKey}.annualCost`, newVal);

//                     const newNet = calculateNetAmount(
//                       newVal,
//                       values.discountAmount,
//                       values.discount
//                     );
//                     formik.setFieldValue(`${sectionKey}.netAmount`, newNet);
//                   }}
//                   error={touched.annualCost && Boolean(errors.annualCost)}
//                   helperText={touched.annualCost && errors.annualCost}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   ส่วนลด
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} lg={2}>
//                 <FormControlLabel
//                   control={
//                     <Radio
//                       checked={values.discount === true}
//                       // onClick={() => {
//                       //   clearOtherSections(sectionKey); // 👈 เพิ่มตรงนี้ก่อน
//                       //   formik.setFieldValue(
//                       //     `${sectionKey}.discount`,
//                       //     values.discount === true ? false : true
//                       //   );
//                       // }}
//                       onClick={() => {
//                         clearOtherSections(sectionKey);
//                         const newDiscount = !values.discount;
//                         formik.setFieldValue(
//                           `${sectionKey}.discount`,
//                           newDiscount
//                         );

//                         if (!newDiscount) {
//                           formik.setFieldValue(
//                             `${sectionKey}.discountAmount`,
//                             ""
//                           );
//                         }

//                         const newNet = calculateNetAmount(
//                           values.annualCost,
//                           values.discountAmount,
//                           newDiscount
//                         );
//                         formik.setFieldValue(`${sectionKey}.netAmount`, newNet);
//                       }}
//                     />
//                   }
//                   label="ให้ส่วนลด"
//                 />
//               </Grid>
//               <Grid item xs={12} lg={4}>
//                 <TextField
//                   fullWidth
//                   label="เปอร์เซ็นที่ลด"
//                   name={`${sectionKey}.discountAmount`}
//                   value={values.discountAmount}
//                   disabled={!values.discount}
//                   inputProps={{ inputMode: "decimal", pattern: "[0-9.]*" }}
//                   // onChange={formik.handleChange}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (/^(\d+(\.\d{0,2})?)?$/.test(value)) {
//                       clearOtherSections(sectionKey);
//                       formik.setFieldValue(
//                         `${sectionKey}.discountAmount`,
//                         value
//                       );

//                       const newNet = calculateNetAmount(
//                         values.annualCost,
//                         value,
//                         values.discount
//                       );
//                       formik.setFieldValue(`${sectionKey}.netAmount`, newNet);
//                     }
//                   }}
//                   error={
//                     touched.discountAmount && Boolean(errors.discountAmount)
//                   }
//                   helperText={touched.discountAmount && errors.discountAmount}
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">%</InputAdornment>
//                     ),
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} lg={4}>
//                 <TextField
//                   fullWidth
//                   label="ยอดเงินสุทธิ"
//                   name={`${sectionKey}.netAmount`}
//                   value={values.netAmount}
//                   onChange={(e) => {
//                     clearOtherSections(sectionKey); // 👈 เคลียร์ก่อน
//                     formik.handleChange(e);
//                   }}
//                   error={touched.netAmount && Boolean(errors.netAmount)}
//                   helperText={touched.netAmount && errors.netAmount}
//                   InputProps={{
//                     readOnly: true,
//                   }}
//                   InputLabelProps={{
//                     shrink: true, // ✅ ทำให้ label ขยับขึ้นตลอด
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} lg={2}>
//                 <Typography variant="subtitle1" sx={{ mb: 1 }}>
//                   หมายเหตุ
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} lg={10}>
//                 <TextField
//                   fullWidth
//                   label="หมายเหตุ"
//                   name={`${sectionKey}.note`}
//                   value={values.note}
//                   // onChange={formik.handleChange}
//                   onChange={(e) => {
//                     clearOtherSections(sectionKey);
//                     formik.handleChange(e);
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Collapse>
//     </Paper>
//   );
// };

const BillDebtForm = () => {
  // const [expandedRow, setExpandedRow] = useState(null);
  const [expandedRow, setExpandedRow] = useState("pawnShop");
  const params = useParams();
  const navigate = useNavigate();

  const [availableTypes, setAvailableTypes] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.super_admin.getCompanyPackage(params.company_id); // 👈 แก้ชื่อ API ให้ตรง
        console.log("API result >", res);

        const typesFromAPI = res.data.map(
          (item) => typeMapping[item.package_type_id]
        );
        setAvailableTypes(typesFromAPI); // ตัวอย่าง: ['pawn', 'car']
        // ถ้าจะ set ค่าใน formik:
        // formik.setFieldValue("item", res.item);
      } catch (error) {
        console.error("โหลดข้อมูลล้มเหลว", error);
      }
    };

    fetchData();
  }, [params.company_id]);

  const formik = useFormik({
    initialValues: {
      invoiceDate: "",
      item: "",
      startDate: "",
      duration: "",
      annualCost: "",
      discount: false,
      note: "",
      discountAmount: 0,
      netAmount: "",
      type: [], // pawn,car,land
    },
    validationSchema: optionalSectionSchema,
    onSubmit: async (values) => {
      const formattedData = {
        company_id: params.company_id,
        data: transformSection(values),
      };
      console.log("formattedData > ", formattedData);

      try {
        const { isStatus } = await api.super_admin.createBill(formattedData);
        if (isStatus) {
          // alert("ส่งข้อมูลสำเร็จแล้ว");
          navigate(`/admin/company/detail/${params.company_id}`);
        } else {
          alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        }
      } catch (error) {
        console.error("Submit error:", error);
        alert("เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
      }
    },
  });

  const calculateNetAmount = (
    annualCostStr,
    discountAmountStr,
    discountFlag
  ) => {
    const cost = parseFloat(annualCostStr);
    const percent = parseFloat(discountAmountStr);

    if (!isNaN(cost)) {
      if (discountFlag && !isNaN(percent) && percent > 0) {
        return (cost - (cost * percent) / 100).toFixed(2);
      } else {
        return cost.toFixed(2);
      }
    }
    return "";
  };
  // const clearOtherSections = (activeSection) => {
  //   const emptySection = {
  //     invoiceDate: "",
  //     item: "",
  //     startDate: "",
  //     duration: "",
  //     annualCost: "",
  //     discount: false,
  //     note: "",
  //     discountAmount: 0,
  //     netAmount: "",
  //   };

  //   const updated = { ...formik.values };

  //   ["pawnShop", "usedCar", "land"].forEach((key) => {
  //     if (key !== activeSection) {
  //       updated[key] = { ...emptySection };
  //     }
  //   });

  //   formik.setValues(updated);
  // };

  // validate อัตโนมัติทุกครั้งที่ submit
  // React.useEffect(() => {
  //   if (formik.submitCount > 0) {
  //     formik.validateForm();
  //   }
  // }, [formik.submitCount]);

  return (
    <>
      <Typography component="div" style={{ fontSize: "32px" }}>
        สร้างใบแจ้งหนี้สำหรับโปรแกรม
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Paper sx={{ mt: 5, p: 2, borderRadius: "12px" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography sx={{ mb: 1, ml: 2 }} variant="h6">
              ใบแจ้งหนี้
            </Typography>
          </Box>
          <Collapse in={true}>
            <Divider />
            <Grid container rowSpacing={3} columnSpacing={2} sx={{ p: 2 }}>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2} lg={2}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      วันที่ออกใบแจ้งหนี้
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <CustomizeDatePicker
                      key={"create-date"}
                      value={formik.values.invoiceDate}
                      onChange={(e) => {
                        formik.setFieldValue("invoiceDate", e);
                      }}
                      error={
                        formik.touched.invoiceDate &&
                        Boolean(formik.errors.invoiceDate)
                      }
                      helperText={
                        formik.touched.invoiceDate && formik.errors.invoiceDate
                      }
                    />
                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        // label="วันที่ออกใบแจ้งหนี้"
                        value={
                          formik.values.invoiceDate
                            ? moment(formik.values.invoiceDate)
                            : null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            "invoiceDate",
                            date ? date.format("YYYY-MM-DD") : ""
                          );
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.invoiceDate &&
                              Boolean(formik.errors.invoiceDate),
                            helperText:
                              formik.touched.invoiceDate &&
                              formik.errors.invoiceDate,
                          },
                        }}
                      />
                    </LocalizationProvider> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2} lg={2}>
                    <Typography variant="subtitle1">ชื่อรายการ</Typography>
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <TextField
                      fullWidth
                      InputProps={{
                        sx: {
                          height: 40,
                        },
                      }}
                      name={"item"}
                      value={formik.values.item}
                      // onChange={formik.handleChange}
                      onChange={(e) => {
                        formik.setFieldValue("item", e.target.value);
                      }}
                      error={formik.touched.item && Boolean(formik.errors.item)}
                      helperText={formik.touched.item && formik.errors.item}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2} lg={2}>
                    <Typography variant="subtitle1">ประเภท</Typography>
                  </Grid>
                  <Grid item xs={12} lg={10}>
                    <FormGroup row>
                      {["pawn", "car", "land"].map((key) => (
                        <FormControlLabel
                          key={key}
                          control={
                            <Checkbox
                              name={key}
                              checked={
                                Array.isArray(formik.values.type) &&
                                formik.values.type.includes(key)
                              }
                              onChange={(e) => {
                                const checked = e.target.checked;
                                let types = Array.isArray(formik.values.type)
                                  ? [...formik.values.type]
                                  : [];

                                if (checked && !types.includes(key)) {
                                  types.push(key);
                                } else if (!checked && types.includes(key)) {
                                  types = types.filter((type) => type !== key);
                                }

                                formik.setFieldValue("type", types);
                              }}
                              disabled={!availableTypes.includes(key)} // 👈 logic ตรงนี้
                              color="primary"
                              size="small"
                            />
                          }
                          label={
                            key === "pawn"
                              ? "ระบบโรงรับจำนำ หรือร้านค้าทั่วไป"
                              : key === "car"
                              ? "ระบบรถมือสอง"
                              : "ระบบที่ดิน"
                          }
                        />
                      ))}
                    </FormGroup>
                    {/* <FormGroup row>
                      {["pawn", "car", "land"].map((key) => (
                        <FormControlLabel
                          key={key}
                          control={
                            <Checkbox
                              name={key}
                              checked={
                                Array.isArray(formik.values.type) &&
                                formik.values.type.includes(key)
                              }
                              onChange={(e) => {
                                const checked = e.target.checked;
                                let types = Array.isArray(formik.values.type)
                                  ? [...formik.values.type]
                                  : [];

                                if (checked && !types.includes(key)) {
                                  types.push(key);
                                } else if (!checked && types.includes(key)) {
                                  types = types.filter((type) => type !== key);
                                }

                                formik.setFieldValue("type", types);
                              }}
                              color="primary"
                              size="small"
                            />
                          }
                          label={
                            key === "pawn"
                              ? "ระบบโรงรับจำนำ หรือร้านค้าทั่วไป"
                              : key === "car"
                              ? "ระบบรถมือสอง"
                              : "ระบบที่ดิน"
                          }
                        />
                      ))}
                    </FormGroup> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} lg={2}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      วันเริ่มใช้งาน
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <CustomizeDatePicker
                      key={"start-date"}
                      value={formik.values.startDate}
                      onChange={(e) => {
                        formik.setFieldValue("startDate", e);
                      }}
                      error={
                        formik.touched.startDate &&
                        Boolean(formik.errors.startDate)
                      }
                      helperText={
                        formik.touched.startDate && formik.errors.startDate
                      }
                    />
                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        // label="เริ่มใช้งาน"
                        value={
                          formik.values.startDate
                            ? formatDateMonthYear(formik.values.startDate)
                            : null
                        }
                        // onChange={(date) =>
                        //   formik.setFieldValue(`${sectionKey}.startDate`, date ? date.format("YYYY-MM-DD") : "")
                        // }
                        onChange={(date) => {
                          formik.setFieldValue(
                            "startDate",
                            date ? date.format("YYYY-MM-DD") : ""
                          );
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.startDate &&
                              Boolean(formik.errors.startDate),
                            helperText:
                              formik.touched.startDate &&
                              formik.errors.startDate,
                          },
                        }}
                      />
                    </LocalizationProvider> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} lg={2}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      ระยะเวลา
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl
                      fullWidth
                      error={
                        formik.touched.duration &&
                        Boolean(formik.errors.duration)
                      }
                    >
                      <Select
                        displayEmpty
                        name="duration"
                        value={formik.values.duration}
                        // onChange={formik.handleChange}
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        sx={{
                          height: "40px",
                        }}
                      >
                        <MenuItem disabled value="">
                          เลือกระยะเวลา
                        </MenuItem>
                        {durationOptions.map((opt) => (
                          <MenuItem key={opt.id} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField
                      fullWidth
                      // label="ค่าบริการ(ต่อปี)"
                      type="number"
                      name="annualCost"
                      value={formik.values.annualCost}
                      // onChange={formik.handleChange}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        formik.setFieldValue("annualCost", newVal);

                        const newNet = calculateNetAmount(
                          newVal,
                          formik.values.discountAmount,
                          formik.values.discount
                        );
                        formik.setFieldValue("netAmount", newNet);
                      }}
                      error={
                        formik.touched.annualCost &&
                        Boolean(formik.errors.annualCost)
                      }
                      helperText={
                        formik.touched.annualCost && formik.errors.annualCost
                      }
                      InputProps={{
                        sx: {
                          height: 40,
                        },
                        startAdornment: (
                          <InputAdornment position="start">฿</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} lg={2}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      ส่วนลด
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={formik.values.discount === true}
                          onClick={() => {
                            const newDiscount = !formik.values.discount;
                            formik.setFieldValue("discount", newDiscount);

                            if (!newDiscount) {
                              formik.setFieldValue("discountAmount", "");
                            }

                            const newNet = calculateNetAmount(
                              formik.values.annualCost,
                              formik.values.discountAmount,
                              newDiscount
                            );
                            formik.setFieldValue("netAmount", newNet);
                          }}
                        />
                      }
                      label="ให้ส่วนลด"
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={12} lg={3}>
                        <Typography>เปอร์เซ็นที่ลด</Typography>
                      </Grid>
                      <Grid item xs={12} lg={9}>
                        <TextField
                          fullWidth
                          // label="เปอร์เซ็นที่ลด"
                          name="discountAmount"
                          value={formik.values.discountAmount}
                          disabled={!formik.values.discount}
                          inputProps={{
                            inputMode: "decimal",
                            pattern: "[0-9.]*",
                          }}
                          // onChange={formik.handleChange}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^(\d+(\.\d{0,2})?)?$/.test(value)) {
                              formik.setFieldValue(`discountAmount`, value);

                              const newNet = calculateNetAmount(
                                formik.values.annualCost,
                                value,
                                formik.values.discount
                              );
                              formik.setFieldValue(`netAmount`, newNet);
                            }
                          }}
                          error={
                            formik.touched.discountAmount &&
                            Boolean(formik.errors.discountAmount)
                          }
                          helperText={
                            formik.touched.discountAmount &&
                            formik.errors.discountAmount
                          }
                          InputProps={{
                            sx: {
                              height: 40,
                            },
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={12} lg={3}>
                        <Typography>ยอดเงินสุทธิ</Typography>
                      </Grid>
                      <Grid item xs={12} lg={9}>
                        <TextField
                          fullWidth
                          // label="ยอดเงินสุทธิ"
                          name="netAmount"
                          value={formik.values.netAmount}
                          onChange={(e) => {
                            formik.handleChange(e);
                          }}
                          error={
                            formik.touched.netAmount &&
                            Boolean(formik.errors.netAmount)
                          }
                          helperText={
                            formik.touched.netAmount && formik.errors.netAmount
                          }
                          InputProps={{
                            readOnly: true,
                            sx: {
                              height: 40,
                            },
                            endAdornment: (
                              <InputAdornment position="end">฿</InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={2}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      หมายเหตุ
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={10}>
                    <TextField
                      fullWidth
                      name="note"
                      value={formik.values.note}
                      // onChange={formik.handleChange}
                      onChange={(e) => {
                        formik.setFieldValue("note", e.target.value);
                      }}
                      error={formik.touched.note && Boolean(formik.errors.note)}
                      helperText={formik.touched.note && formik.errors.note}
                      multiline
                      InputProps={{
                        sx: {
                          height: 40,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
        {/* <SectionForm
          title="ใบแจ้งหนี้"
          sectionKey="pawnShop"
          formik={formik}
          expandedRow={expandedRow}
          handleExpandClick={setExpandedRow}
          clearOtherSections={clearOtherSections}
        /> */}
        {/* <SectionForm
          title="รถมือสอง"
          sectionKey="usedCar"
          formik={formik}
          expandedRow={expandedRow}
          handleExpandClick={setExpandedRow}
          clearOtherSections={clearOtherSections}
        /> */}
        {/* <SectionForm
          title="ที่ดิน"
          sectionKey="land"
          formik={formik}
          expandedRow={expandedRow}
          handleExpandClick={setExpandedRow}
          clearOtherSections={clearOtherSections}
        /> */}
        <Grid container justifyContent="center" spacing={2} sx={{ mt: 3 }}>
          <Grid item>
            <GradientButtonOutline onClick={() => window.history.back()}>
              กลับ
            </GradientButtonOutline>
          </Grid>
          <Grid item>
            <GradientButton type="submit">บันทึก</GradientButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default BillDebtForm;
